<script setup lang="ts">
import type { BreadcrumbItem } from '~/types/breadcrumbs'

defineProps<{
  items: BreadcrumbItem[]
}>()
</script>

<template>
  <div class="bg-white/50 backdrop-blur shadow-raised">
    <div class="content flex items-center py-10">
      <NuxtLink to="/news">
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M20 7.093V2H17V4.093L20 7.093ZM24 13L12 1L0 13H3V23H10V18H14V23H21V13H24ZM19 21H16V16H8V21H5V10.74L12 3.828L19 10.818V21Z"
            fill="black"
          />
        </svg>
      </NuxtLink>
      <template v-for="(item, index) in items" :key="index">
        <span class="divider">
          <svg
            width="10"
            viewBox="0 0 13 13"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clip-path="url(#clip0_1000_185)">
              <path
                d="M2.70825 1.625L4.36413 0L10.8333 6.5L4.36413 13L2.70825 11.375L7.58325 6.5L2.70825 1.625Z"
                fill="black"
              />
            </g>
          </svg>
        </span>
        <template v-if="item.isActive && item.link">
          <NuxtLink :to="item.link" class="relative top-[1px]"
            >{{ item.label }}
          </NuxtLink>
        </template>
        <span v-else class="breadcrumb-label relative top-[1px]">{{
          item.label
        }}</span>
      </template>
    </div>
  </div>
</template>

<style scoped lang="postcss">
a {
  @apply no-underline font-bold text-base;
}

.divider {
  @apply inline-block mx-15 sm:mx-20;
}
</style>
